import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { faqs } from '@/mocks/home';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
        <div>
          <SectionHeading
            eyebrow="常见问题"
            title="关于 17.cc 吃瓜，你可能想知道的"
            desc="我们把新手最常问的问题整理在这里，从「怎么吃瓜」到「怎么辨别信息」，一次说清楚。"
          />
          <div className="mt-8 rounded-lg border border-accent-200/70 bg-accent-50 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-chat-quote-line text-lg" aria-hidden="true"></i>
            </span>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              还有别的问题？欢迎直接给我们留言，我们会在整理后补充到这份攻略里。
            </p>
            <a
              href="#about"
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap font-label text-sm font-medium text-accent-700 transition-colors hover:text-accent-800"
            >
              前往留言咨询
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? 'border-primary-300/70 bg-background-50' : 'border-background-200/80 bg-background-50'
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'} aria-hidden="true"></i>
                    </span>
                  </button>
                </h3>
                {isOpen ? (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}